import * as React from 'react'
import { TitleMode } from '../../../common/const'
import { useTranslation } from 'react-i18next'
import { InvoiceMerchantTitle, InvoiceMerchantTitleIcon } from './InvoiceTitle.style'

interface InvoiceTitleProps {
  templateConfigurationName?: string
  fullScreenPopup?: boolean
  merchantInvoiceTitle?: string
  merchantInvoiceType?: string
  titleMode?: TitleMode.DEFAULT | TitleMode.SWAPPED | TitleMode.NO_ORIGINAL_MERCHANT
}

const InvoiceTitle = ({
  templateConfigurationName,
  fullScreenPopup,
  merchantInvoiceTitle,
  merchantInvoiceType,
  titleMode
}: InvoiceTitleProps) => {
  const { t } = useTranslation()

  // @todo this logic should be moved out when planning the webclient 2.0
  // And each business area should be isolated with its own logic and data
  // Conditional rendering should not be done in component level. components are only should be displaying data which comes through props
  // Decision making should be done in the parent or routes level
  // This is an exceptional case where we need to show different title for different merchants without doing heavy refactoring
  const isSynsamOrWickstroms =
    templateConfigurationName?.includes('afs_synsam') ||
    templateConfigurationName?.includes('afs_wickstroms')

  return (
    <>
      {isSynsamOrWickstroms ? (
        <InvoiceMerchantTitleIcon>
          <img src="/img/synsam.svg" alt="Merchant Logo" />
        </InvoiceMerchantTitleIcon>
      ) : (
        <InvoiceMerchantTitle fullScreenPopup={fullScreenPopup}>
          <h1>
            {!titleMode || titleMode === TitleMode.DEFAULT
              ? merchantInvoiceTitle
              : t(merchantInvoiceType!)}
          </h1>
          {!fullScreenPopup && titleMode !== TitleMode.NO_ORIGINAL_MERCHANT && (
            <h2>
              {titleMode === TitleMode.SWAPPED ? merchantInvoiceTitle : t(merchantInvoiceType!)}
            </h2>
          )}
        </InvoiceMerchantTitle>
      )}
    </>
  )
}

export default InvoiceTitle
